export default "__VITE_ASSET__BOwkLYpq__"